import IconPermissionDenied from '../icons/permission-denied';

import styles from './permission-denied.module.css';

export default function PermissionDenied() {
  return (
    <div className={styles.permissionDeniedWrapper}>
      <div className={styles.permissionDeniedError}>403: Access denied</div>
      <div className={styles.permissionDeniedContent}>
        <IconPermissionDenied className={styles.premissionDeniedIcon} />
        <div className={styles.permissionDeniedTitle}>
          You do not have access to this section
        </div>
        <div className={styles.permissionDeniedDescription}>
          If this is an error, contact your administrator
        </div>
      </div>
    </div>
  );
}
